import React from "react";
import Button from "../Button";
import LayoutButtons from "../LayoutButtons";
import Box from "../Box";
// eslint-disable-line

const DrawerFormsActions = _ref => {
  let {
    onSaveContentModal,
    onClearForm,
    // eslint-disable-line 
    onClose,
    labelSaveDrawerForm,
    labelClose
  } = _ref;
  return /*#__PURE__*/React.createElement(LayoutButtons, null, /*#__PURE__*/React.createElement(Box, {
    className: "drawer-footer-actions"
  }, /*#__PURE__*/React.createElement(Button, {
    sx: {
      float: 'right',
      ml: 2
    },
    variant: "contained",
    onClick: onSaveContentModal
  }, labelSaveDrawerForm), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    onClick: onClose
  }, labelClose)));
};
export default DrawerFormsActions;